import { Component } from '@angular/core';

@Component({
    selector: 'scrawlbrawl-logo-vertical',
    templateUrl: '../../../../../../src/assets/svgs/scrawlbrawl-vertical.svg',
    styleUrls: ['../svg.component.scss']
})
export class ScrawlBrawlLogoVertical {
    
}